import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, SectionTitle } from "@/components/Kpi";
import { eur, num } from "@/lib/format";

const quando = (iso) => new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });

/** Notifica push aperta per intero (tutte le righe, anche quelle tagliate dal sistema). */
export default function NotificaPush() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [errore, setErrore] = useState(false);
  useEffect(() => {
    api.get(`/push/log/${id}`).then((r) => setD(r.data)).catch(() => setErrore(true));
  }, [id]);

  if (errore) {
    return (
      <div data-testid="notifica-push-page">
        <SectionTitle sub="La notifica non è disponibile o appartiene a un altro utente.">Notifica</SectionTitle>
        <Link to="/" className="text-sm text-sky-700 hover:text-sky-900" data-testid="notifica-torna-home">← Torna alla home</Link>
      </div>
    );
  }
  if (!d) return <div className="text-sm text-slate-500" data-testid="notifica-push-page">Caricamento…</div>;
  const dettaglio = d.dettaglio || [];
  return (
    <div data-testid="notifica-push-page">
      <SectionTitle sub={`Ricevuta il ${quando(d.ts)}`}
        right={d.url_origine && d.url_origine !== "/" && (
          <Link to={d.url_origine} data-testid="notifica-apri-origine"
            className="px-4 py-2 rounded-md bg-[#0018A8] text-white text-sm hover:bg-[#001480] transition-colors duration-200">
            Apri nella sezione
          </Link>
        )}>
        {d.titolo}
      </SectionTitle>
      <Card className="p-6 mb-6" data-testid="notifica-corpo">
        <div className="text-sm text-slate-700 whitespace-pre-line">{d.corpo}</div>
      </Card>
      {dettaglio.length > 0 && (
        <Card className="p-0 overflow-hidden" data-testid="notifica-dettaglio">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">Convenzionato</th>
                <th className="px-4 py-2 text-right text-xs font-semibold uppercase tracking-wider text-slate-500">Pratiche</th>
                <th className="px-4 py-2 text-right text-xs font-semibold uppercase tracking-wider text-slate-500">Importo</th>
                <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">Numeri pratica</th>
              </tr>
            </thead>
            <tbody>
              {dettaglio.map((r) => (
                <tr key={r.convenzionato} className="border-b border-slate-100">
                  <td className="px-4 py-2 text-sm text-slate-800">{r.convenzionato}</td>
                  <td className="px-4 py-2 text-sm text-right font-mono">{num(r.pratiche)}</td>
                  <td className="px-4 py-2 text-sm text-right font-mono">{r.importo ? eur(r.importo) : "n/d"}</td>
                  <td className="px-4 py-2 text-xs font-mono text-slate-500">{(r.numeri || []).join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
